import React, { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { PackageX, AlertTriangle } from "lucide-react";

export default function LowStockCard() {
  const { api, lang } = useApp();
  const nav = useNavigate();
  const zh = lang === "zh";
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/warehouses/low-stock").then((r) => setRows(r.data?.rows || [])).catch(() => {});
  }, [api]);

  if (!rows.length) return null;

  return (
    <div data-testid="low-stock-card" className="bg-white rounded-xl border border-red-200 p-5 cursor-pointer hover:border-red-300 transition-colors"
      onClick={() => nav("/warehouses")}>
      <div className="flex items-center gap-2 mb-3">
        <PackageX className="h-4 w-4 text-brand-500" />
        <h3 className="font-semibold text-slate-900">{zh ? "仓库低库存提醒（跨分公司）" : "Low Stock Alerts"}</h3>
        <span data-testid="low-stock-count" className="ml-1 text-xs font-semibold text-red-600 bg-red-50 px-2 py-0.5 rounded-full">{rows.length} {zh ? "项" : "items"}</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {rows.slice(0, 9).map((r) => (
          <div key={`${r.warehouseId}-${r.key}`} data-testid={`low-stock-${r.warehouseId}-${r.key}`} className="flex items-center justify-between bg-red-50 rounded-lg px-3 py-2 text-sm">
            <div className="min-w-0">
              <p className="text-slate-800 truncate">{r.name}</p>
              <p className="text-[10px] text-slate-400 truncate">{r.warehouseName}</p>
            </div>
            <span className="flex items-center gap-1 text-red-600 font-semibold flex-shrink-0"><AlertTriangle className="h-3 w-3" />{r.qty}/{r.threshold}</span>
          </div>
        ))}
      </div>
      {rows.length > 9 && <p className="text-[11px] text-slate-400 mt-2">{zh ? `等共 ${rows.length} 项 · 点击进入仓库管理` : `+${rows.length - 9} more`}</p>}
    </div>
  );
}
